/**
 * Detects whether <input type="date" /> and <input type="datetime-local" /> are natively supported so that custom datepickers can only be applied where necessary.
 * Other input types can be appended to the array of check types if necessary.
*/

import EventBus from './../event-bus.js'

const InputTypeSupportModule = {
    
    /**
     * Broadcast support
    */
    broadcastSupport() {
        
        const types = ['date', 'datetime-local']
        var hash = {}
        
        for (var type of types) {
            hash[type] = this.checkSupport(type)
        }
        
        EventBus.publish('input-support-checked', hash)
        
    },
    
    /**
     * Check support of input type
     * @param type
     * @return boolean
    */
    checkSupport(type) {
        var input = document.createElement('input')
        input.setAttribute('type', type)
        return input.type !== 'text'
    },
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('modules-initialised', this.broadcastSupport.bind(this))
    }
    
}

InputTypeSupportModule.bindEvents()

export default InputTypeSupportModule